import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { PhoneIcon } from "src/components/icons/MediaIcons";
import { formattedPhoneString } from "src/components/js/statics1";

export default function GridKeikkaEditor_Teksti_Row({
  title,
  sub,
  children,
  gray = false,
  phone = null,
  right = null,
}) {
  return (
    <div
      className={gray ? "harmaaTausta" : ""}
      style={{
        alignItems: "center",
        paddingLeft: 8,
      }}>
      <Typography variant="h6" color="primary">
        {title}
      </Typography>
      <Typography variant="body" color="primary" sx={{ whiteSpace: "pre-line" }}>
        {sub}
      </Typography>
      <div style={{ flexGrow: 1 }}>{children}</div>
      {phone && (
        <div className="spaceBetween">
          <Typography variant="body1" color="primary">
            {formattedPhoneString(phone)}{" "}
          </Typography>
          <Button
            tabIndex={-1}
            disabled={false}
            variant="outlined"
            size="small"
            onClick={() => window.open(`tel:${phone}`)}>
            <PhoneIcon />
          </Button>
        </div>
      )}
      {right}
    </div>
  );
}

GridKeikkaEditor_Teksti_Row.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // title can be a string or a node
  sub: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // subText can be a string or a node
  children: PropTypes.node,
  gray: PropTypes.bool,
  phone: PropTypes.string,
  right: PropTypes.node,
};
